import React from 'react';
import { Button, Container, Grid, Typography } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { motion } from 'framer-motion';

const Eccomerce = () => {
	const textAnimation = {
		hidden: { x: -100, opacity: 0 },
		visible: { x: 0, opacity: 1 },
	};

	const imageAnimation = {
		hidden: { x: 100, opacity: 0 },
		visible: { x: 0, opacity: 1 },
	};

	return (
		<>
			<Container sx={{ marginTop: '40px' }}>
				<motion.div
					initial='hidden'
					whileInView='visible'
					viewport={{ once: true, amount: 0.2 }}
					transition={{ duration: 1 }}
					variants={textAnimation}>
					<Typography variant='h4' gutterBottom>
						eCommerce Website Development Company
					</Typography>
					<Typography variant='h6'>
						An experienced team of eCommerce developers to deliver your dream
						online store.
					</Typography>
					<Typography paragraph>
						The core objective of eCommerce website development is to provide
						the users with a store-like shopping experience and provide the
						administrator with easy management facilities. At Webguru
						Infosystems, an ISO 9001:2015 certified eCommerce website
						development company in India, we take care of both requirements by
						following all industry benchmarks.
					</Typography>
				</motion.div>

				<Grid container spacing={6} alignItems='center'>
					<Grid item xs={12} md={7}>
						<motion.div
							initial='hidden'
							whileInView='visible'
							viewport={{ once: true, amount: 0.2 }}
							transition={{ duration: 1 }}
							variants={textAnimation}>
							<Typography
								variant='h6'
								gutterBottom
								sx={{
									fontWeight: 'bold',
									display: 'flex',
									alignItems: 'center',
									marginTop: '20px',
								}}>
								<PeopleAltIcon
									sx={{
										fontSize: '28px',
										color: '#613da7',
										marginRight: '8px',
									}}
								/>
								The Users
							</Typography>
							<Grid container spacing={4}>
								{[...Array(3)].map((_, index) => (
									<Grid item xs={12} md={4} key={`user-feature-${index}`}>
										<ul style={{ listStyle: 'none', paddingLeft: 0 }}>
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													marginBottom: '10px',
												}}>
												<KeyboardArrowRightIcon
													sx={{ color: '#613da7', marginRight: '8px' }}
												/>
												Easy Navigation & Engaging Interface
											</li>
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													marginBottom: '10px',
												}}>
												<KeyboardArrowRightIcon
													sx={{ color: '#613da7', marginRight: '8px' }}
												/>
												Secure Transactions & Fast Checkout
											</li>
										</ul>
									</Grid>
								))}
							</Grid>
						</motion.div>

						<motion.div
							initial='hidden'
							whileInView='visible'
							viewport={{ once: true, amount: 0.2 }}
							transition={{ duration: 1 }}
							variants={textAnimation}>
							<Typography
								variant='h6'
								gutterBottom
								sx={{
									fontWeight: 'bold',
									display: 'flex',
									alignItems: 'center',
									marginTop: '20px',
								}}>
								<PeopleAltIcon
									sx={{
										fontSize: '28px',
										color: '#613da7',
										marginRight: '8px',
									}}
								/>
								The Administrator
							</Typography>
							<Grid container spacing={4}>
								{[...Array(3)].map((_, index) => (
									<Grid item xs={12} md={4} key={`admin-feature-${index}`}>
										<ul style={{ listStyle: 'none', paddingLeft: 0 }}>
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													marginBottom: '10px',
												}}>
												<KeyboardArrowRightIcon
													sx={{ color: '#613da7', marginRight: '8px' }}
												/>
												Advanced Dashboard & Analytics
											</li>
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													marginBottom: '10px',
												}}>
												<KeyboardArrowRightIcon
													sx={{ color: '#613da7', marginRight: '8px' }}
												/>
												Easy Inventory Management
											</li>
										</ul>
									</Grid>
								))}
							</Grid>
						</motion.div>
					</Grid>

					<Grid item xs={12} md={5}>
						<motion.div
							initial='hidden'
							whileInView='visible'
							viewport={{ once: true, amount: 0.2 }}
							transition={{ duration: 1 }}
							variants={imageAnimation}>
							<img
								src='https://www.webguru-india.com/assets/images/ecommerce-website-design-services-layout-design.png'
								alt='Ecommerce layout design'
								style={{ width: '100%', height: 'auto', marginBottom: '20px' }}
							/>
						</motion.div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default Eccomerce;
